import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../Service/axiosClient";
export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (lastPostId = null, { rejectWithValue }) => {
    try {
      const tokens = localStorage.getItem("token");
      const url = lastPostId
        ? `/api/Post/getallpost?lastPostId=${lastPostId}`
        : "/api/Post/getallpost";
      // console.log("Đang chạy", url);
      const response = await axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${tokens}` },
      });

      // Handle case when no more posts are available
      if (response.data.message === "Không còn bài viết nào để load") {
        return {
          posts: [],
          hasMore: false,
        };
      }

      return {
        posts: response.data.data.posts,
        hasMore: response.data.data.nextCursor !== null,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching posts");
    }
  }
);

//Like bài viết
export const likePost = createAsyncThunk("posts/likePosts", async (postId) => {
  const token = localStorage.getItem("token");
  await axiosInstance.post(
    "/api/Like/like",
    { postId: postId },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return postId;
});

//Load Comment All Comment
export const commentPost = createAsyncThunk(
  "posts/commentPost",
  async ({ postId, lastCommentId = null }, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    try {
      const url = lastCommentId
        ? `/api/Comment/GetCommentByPost?PostId=${postId}&lastCommentId=${lastCommentId}`
        : `/api/Comment/GetCommentByPost?PostId=${postId}`;

      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        postId,
        comments: response.data.data.comments,
        hasMore: response.data.data.lastCommentId !== null,
        isInitialLoad: !lastCommentId,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Lỗi không xác định");
    }
  }
);
//AddComment post
export const addCommentPost = createAsyncThunk(
  "posts/addCommentPost",
  async ({ postId, content, userId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.post(
        "/api/Comment/CommentPost",
        {
          postId: postId,
          content: content,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.data.success) {
        toast.warning("Bình luận của bạn có ngôn từ không chuẩn mực!");
      }
      // return response.data;
      return { postId, data: response.data.data, userId };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Có lỗi xảy ra");
    }
  }
);

//LikeComment
export const likeComment = createAsyncThunk(
  "posts/likeComment",
  async (commentId, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    try {
      const response = await axiosInstance.post(
        `/api/CommentLike/like/${commentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return commentId;
    } catch (error) {
      return rejectWithValue(error.response?.data || " Đã có lỗi ");
    }
  }
);

// Đăng bài
export const createPost = createAsyncThunk(
  "post/createPost",
  async ({ formData, fullName, profilePicture }, { rejectWithValue }) => {
    const token = localStorage.getItem("token");
    const toastId = toast.loading("Đang đăng bài...");

    try {
      const response = await axiosInstance.post("/api/Post/create", formData, {
        headers: {
          Authorization: `Bearer ${token}`, // Gửi token trong header
        },
      });

      if (response.data.success) {
        toast.update(toastId, {
          render: response.data.message || "Đăng bài thành công!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });

        return {
          fullName,
          profilePicture,
          ...response.data.data,
          updateAt: null,
          commentCount: 0,
          likeCount: 0,
          shareCount: 0,
          hasLiked: false,
          isSharedPost: false,
        };
      } else {
        toast.update(toastId, {
          render: response.data.message || "Đăng bài thất bại!",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
        return rejectWithValue(response.data.errors);
      }
    } catch (error) {
      toast.update(toastId, {
        render: error.response?.data?.message || "Lỗi không xác định!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });

      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//Chỉnh sửa bài viết
export const updatePost = createAsyncThunk(
  "posts/updatePost",
  async (
    { postId, formData, fullName, profilePicture, createdAt },
    { rejectWithValue }
  ) => {
    const token = localStorage.getItem("token");
    try {
      // console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]); // In key và value của FormData
      }

      const response = await axiosInstance.patch(
        "/api/Post/update-post",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
          },
        }
      );
      console.log("Response từ API Update>>", response.data); // Kiểm tra response trả về
      if (response.data.data) {
        toast.success("Sửa bài viết thành công!");
        return {
          postId,
          data: response.data.data,
          fullName,
          profilePicture,
          createdAt,
        };
      } else {
        toast.error("Sửa bài viết không thành công!");
        return rejectWithValue("Dữ liệu trả về không hợp lệ");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//Xóa bài viết
export const deletePost = createAsyncThunk(
  "posts/deletePost",
  async (postID, { rejectWithValue }) => {
    // console.log("postID nhận được:", postID, "Loại:", typeof postID);
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.delete(
        `/api/Post/delete?PostId=${postID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
          },
        }
      );
      // console.log("Xóa bài viết thành công!", response.data);
      return postID;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//Lấy comment reply
export const getReplyComment = createAsyncThunk(
  "post/getReplyComment",
  async (commentId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.get(
        `/api/Comment/replies?ParentCommentId=${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
          },
        }
      );
      console.log("Data comment reply", response.data.data.replies);
      return { commentId, data: response.data.data.replies };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//Xóa comment
export const deleteComments = createAsyncThunk(
  "posts/deleteComments",
  async ({ postId, commentId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.patch(
        `/api/Comment/DeleteComment/${commentId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
          },
        }
      );
      console.log("Xóa comment thành công");
      return { postId, commentId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//Reply comment
export const replyComments = createAsyncThunk(
  "post/replyComments",
  async ({ postId, parentId, content, userId }, { rejectWithValue }) => {
    // console.log("Id cha>>", parentId);
    // console.log("Id post>>", parentId);
    // console.log("Id content>>", parentId);
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.post(
        "/api/Comment/ReplyComment",
        {
          postId: postId,
          parentCommentId: parentId,
          content: content,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Gửi token trong header
          },
        }
      );
      if (!response.data.success) {
        toast.warning("Bình luận của bạn có ngôn từ không chuẩn mực!");
      }
      console.log("Trả về data", response.data.data);
      return { postId, data: response.data.data, userId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

//listpostaction
export const sharePost = createAsyncThunk(
  "post/sharePost",
  async (
    { postId, content, fullName, profilePicture, privacy },
    { rejectWithValue }
  ) => {
    const toastId = toast.loading("Đang chia sẻ bài viết...");
    try {
      const token = localStorage.getItem("token");
      // if (!token) throw new Error('Vui lòng đăng nhập');

      const response = await axiosInstance.post(
        "/api/Share/SharePost",

        { postId, content, privacy },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Chia sẻ thất bại");
      }

      toast.update(toastId, {
        render: response.data.message || "Chia sẻ bài viết thành công!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      const apiData = response.data.data;

      return {
        id: apiData.id,
        userId: apiData.userId,
        fullName: fullName || apiData.fullName,
        profilePicture: profilePicture || apiData.profilePicture,
        content: apiData.content,
        imageUrl: apiData.imageUrl || null,
        videoUrl: apiData.videoUrl || null,
        createdAt: apiData.createdAt,
        updateAt: null,
        commentCount: 0,
        likeCount: 0,
        shareCount: 0,
        hasLiked: false,
        isSharedPost: true,
        postType: 1,
        privacy: apiData.privacy,
        scope: apiData.scope,
        originalPost: {
          postId: apiData.originalPost.postId,
          content: apiData.originalPost.content,
          author: apiData.originalPost.author.userName,
          createAt: apiData.originalPost.createAt,
          imageUrl: apiData.originalPost.imageUrl || null,
          videoUrl: apiData.originalPost.videoUrl || null,
          scope: apiData.originalPost.scope,
        },
      };
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.message;
      toast.update(toastId, {
        render: errorMsg || "Chia sẻ bài viết thất bại!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      return rejectWithValue({
        message: errorMsg,
        code: error.response?.status,
      });
    }
  }
);

// Lấy bài viết của người sở hữu (tự động lấy theo token)
export const fetchPostsByOwner = createAsyncThunk(
  "posts/fetchPostsByOwner",
  async (lastPostId = null, { rejectWithValue }) => {
    try {
      const tokens = localStorage.getItem("token");
      const url = lastPostId
        ? `/api/Post/GetPostsByOwner?lastPostId=${lastPostId}`
        : "/api/Post/GetPostsByOwner";

      const response = await axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${tokens}` },
      });
      // Handle case when no more posts are available
      if (response.data.message === "Không còn bài viết nào để load") {
        return {
          posts: [],
          hasMore: false,
        };
      }
      return {
        posts: response.data.data.posts,
        hasMore: response.data.data.nextCursor !== null,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching owner posts"
      );
    }
  }
);

export const fetchPostsByOtherUser = createAsyncThunk(
  "posts/fetchPostsByOtherUser",
  async ({ userId, lastPostId = null }, { rejectWithValue }) => {
    try {
      const tokens = localStorage.getItem("token");
      const url = lastPostId
        ? `/api/Post/GetPostsByOwnerFriend?userId=${userId}&lastPostId=${lastPostId}`
        : `/api/Post/GetPostsByOwnerFriend?userId=${userId}`;

      const response = await axiosInstance.get(url, {
        headers: { Authorization: `Bearer ${tokens}` },
      });

      if (response.data.message === "Không còn bài viết nào để load") {
        return {
          posts: [],
          hasMore: false,
        };
      }
      return {
        posts: response.data.data.posts,
        hasMore: response.data.data.nextCursor !== null,
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error fetching owner posts"
      );
    }
  }
);
// Thêm action để chỉnh sửa comment
export const updateComment = createAsyncThunk(
  "posts/updateComment",
  async ({ postId, commentId, content }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.patch(
        "/api/Comment/UpdateComment",
        {
          PostId: postId,
          CommentId: commentId,
          Content: content,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        toast.success("Cập nhật bình luận thành công!");
        return { postId, commentId, content };
      } else {
        toast.error("Cập nhật bình luận không thành công!");
        return rejectWithValue("Cập nhật không thành công");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Lỗi khi cập nhật bình luận"
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
